<template>
  <div class="layout">
    <div :style="obj.style()">
      <input type="text" v-model="obj.text" class="input">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentSpacer',

  props: [
    'obj'
  ]
}
</script>

<style scoped>
  .layout {
    text-align: center;
  }

  .input {
    padding: 0;

    background: transparent;
    border: 0;
    color: inherit;
    text-align: inherit;
  }
</style>
